module.exports = __webpack_public_path__ + "img/huochepiao.207be3c1.png";